import { memo } from "react";
import * as Styled from "./style";
import { SamplePackageImage } from "~/components/blocks/common/sample-package-image";
import { SampleVisualImage } from "~/components/blocks/product/detail/sample-visual-image";
import { useImageSrcFormat } from "~/hooks/use-image-src-format";
import type { Maybe } from "~/lib/graphql";

type SampleSpotLiveAssetProps = {
  keyVisualImage: Maybe<string> | undefined;
  keyVisualWithoutLogoImage: Maybe<string> | undefined;
  packageImage: string;
};

export const SampleSpotLiveAsset = memo((props: SampleSpotLiveAssetProps) => {
  const { packageImage, keyVisualImage, keyVisualWithoutLogoImage } = props;

  const { imageSrcFormat } = useImageSrcFormat({ aspectRatio: "LANDSCAPE" });

  if (keyVisualImage) {
    return (
      <>
        <SampleVisualImage
          {...imageSrcFormat({ imgSrc: keyVisualImage, size: { w: 1920, h: 1080 } })}
          alt="ロゴがあるキービジュアル画像"
        />
        <Styled.VideoForSeoOptimization />
      </>
    );
  }

  if (keyVisualWithoutLogoImage) {
    return (
      <>
        <SampleVisualImage
          {...imageSrcFormat({ imgSrc: keyVisualWithoutLogoImage, size: { w: 1920, h: 1080 } })}
          alt="ロゴがないキービジュアル画像"
        />
        <Styled.VideoForSeoOptimization />
      </>
    );
  }

  if (packageImage) {
    return (
      <>
        <SamplePackageImage packageImageUrl={packageImage} />
        <Styled.VideoForSeoOptimization />
      </>
    );
  }

  return null;
});

SampleSpotLiveAsset.displayName = "SampleSpotLiveAsset";
